import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

const SubContractorType = () => {
  return (
    <SettingsMetaData propertyName={"subConType_Supplier"} viewPropertyName={"Sub-Contractor Type "} />

  )
}

export default SubContractorType